/**
 * @see {@link https://en.wikipedia.org/wiki/Decimal_separator#/media/File:DecimalSeparator.svg}
 */
export enum DecimalSeparator {
	ARABIC_COMMA = '٫',
	COMMA = ',',
	DOT = '.',
}
